import * as formatHelper from "../../helpers/formatHelper";

/**
 * @class Margin
 */
export default class Margin {
    /**
     * @param {Number}  id
     * @param {String}  name
     * @param {Boolean} visible
     * @param {Boolean} local
     * @param {Number}  type
     * @param {Number}  procBases
     * @param {Number}  procColorants
     */
    constructor(id, name, visible, local, type, procBases = 0, procColorants = 0) {
        this._id = id;
        this._name = name;
        this._visible = visible;
        this._local = local;
        this._type = type;
        this._procBases = procBases;
        this._procColorants = procColorants;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Margin");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number}  id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String}  name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {Boolean}
     */
    get visible() {
        return this._visible;
    }

    /**
     * @param {Boolean} visible
     */
    set visible(visible) {
        this._visible = visible;
    }

    /**
     * @return {Boolean}
     */
    get local() {
        return this._local;
    }

    /**
     * @param {Boolean} local
     */
    set local(local) {
        this._local = local;
    }

    /**
     * @return {Number}
     */
    get type() {
        return this._type;
    }

    /**
     * @param {Number}  type
     */
    set type(type) {
        this._type = type;
    }

    /**
     * @return {Number}
     */
    get procBases() {
        return this._procBases;
    }

    /**
     * @param {Number}  procBases
     */
    set procBases(procBases) {
        this._procBases = procBases;
    }

    /**
     * @return {Number}
     */
    get procColorants() {
        return this._procColorants;
    }

    /**
     * @param {Number}  procColorants
     */
    set procColorants(procColorants) {
        this._procColorants = procColorants;
    }

    /**
     * @return {Object}
     */
    clone() {
        return new Margin(
            this._id,
            this._name,
            this._visible,
            this._local,
            this._type,
            this._procBases,
            this._procColorants
        );
    }

    /**
     * Clones Margin object and updates visible property.
     *
     * @param   {Boolean}   visible
     * @return  {Object}
     */
    updateVisible = (visible) => {
        let clone = this.clone();
        clone.visible = visible;

        return clone;
    };

    /**
     * @return {String}
     */
    formatProcBases() {
        return formatHelper.formatMarginPercent(this._procBases);
    }

    /**
     * @return {String}
     */
    formatProcColorants() {
        return formatHelper.formatMarginPercent(this._procColorants);
    }

    /**
     * @return {String}
     */
    getKey() {
        if (this._local) {
            return "local-" + this._id;
        }

        return "default-" + this._id;
    }

    /**
     * @return {String}
     */
    toString() {
        return "Margin (" + this._id + ")";
    }
}
